module.exports = __webpack_public_path__ + "img/plant-pot.b8b03607.png";